import React from "react";
import "./faq.css";
import styles from "./FaqSection.module.css";
import { Accordion, Container } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { LightBgButton } from "../Buttons/LightBgButton";

const FaqSection = ({ handleShow }) => {
  return (
    <React.Fragment>
      <div className={styles.main_section} id="faq">
        <Container>
          <div className={styles.aboutChild}>
            <div>
              {/* <button>FAQs</button> */}
              <LightBgButton label={'FAQs'} bg="#CCD7FF" color="var(--primary-color)" />

              <Heading>
                Got Questions? We’ve Got <br /> Answers
              </Heading>
              <Paragraph>Find your queries in the questions</Paragraph>
            </div>
            {/* <button className={styles.btn}>
              Consult How <MdOutlineArrowOutward />
            </button> */}
          </div>

          <div className={styles.faqSection}>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0">
                <Accordion.Header>What services does BuildShell offer?</Accordion.Header>
                <Accordion.Body>
                  <h2>We specialize in:</h2>
                  <ul>
                    <li><span className="checkmark">✅</span> <strong>Web & Mobile App Development</strong> – Scalable iOS, Android & Web apps.</li>
                    <li><span className="checkmark">✅</span> <strong>UI/UX Design</strong> – User-friendly, conversion-focused designs.</li>
                    <li><span className="checkmark">✅</span> <strong>Custom Software Development</strong> – Tailored solutions for businesses.</li>
                    <li><span className="checkmark">✅</span> <strong>AI & Machine Learning</strong> – Smart automation & data-driven insights.</li>
                    <li><span className="checkmark">✅</span> <strong>SaaS & Cloud Solutions</strong> – Secure, scalable cloud-based applications.</li>
                    <li><span className="checkmark">✅</span> <strong>E-commerce Development</strong> – High-converting online stores.</li>
                    <li><span className="checkmark">✅</span> <strong>Cybersecurity & Compliance</strong> – Protecting businesses from cyber threats.</li>
                  </ul>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>How does the Buildshell development process work?</Accordion.Header>
                <Accordion.Body>
                  <h2>Our process includes:</h2>
                  <ul>
                    <li><span className="icon">✅</span> <strong>Consultation & Planning</strong> – Understanding your needs.</li>
                    <li><span className="icon">✅</span> <strong>UI/UX Wireframing & Prototyping</strong> – Creating intuitive designs.</li>
                    <li><span className="icon">✅</span> <strong>Development & Testing</strong> – Coding and ensuring quality.</li>
                    <li><span className="icon">✅</span> <strong>Deployment & Support</strong> – Launching and ongoing maintenance.</li>
                  </ul>

                  <p className="cta">📌 <strong>Want to discuss your project?</strong> <button onClick={handleShow} className="btn btn-sm border-primary text-primary">Book a Free Call</button></p>

                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>How much does Buildshell cost to develop an app/website/software?</Accordion.Header>
                <Accordion.Body>
                  <p>The cost depends on the <span className="highlight">complexity, features, and technology used.</span> We provide <span className="highlight bold">custom quotes</span> after understanding your business needs.</p>
                  <p className="cta">📌 <strong>Get a personalized quote here!</strong> <button onClick={handleShow} className="btn btn-sm border-primary text-primary">Request a Quote</button></p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>How long does Buildshell team take to build a project?</Accordion.Header>
                <Accordion.Body>
                  <ul>
                    <li><strong>Simple website/app</strong> – 4-6 weeks</li>
                    <li><span className="icon">🔹</span> <strong>Medium-sized project</strong> – 8-12 weeks</li>
                    <li><span className="icon">🔹</span> <strong>Large enterprise solution</strong> – 4-6 months</li>
                  </ul>
                  <p className="cta">📌 <strong>Timelines vary based on complexity.</strong> <button onClick={handleShow} className="btn btn-sm border-primary text-primary">Discuss Your Project</button></p>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Do you provide ongoing support & maintenance?</Accordion.Header>
                <Accordion.Body>
                  <p>Yes! Buildshell offer <span className="highlight">long-term support & maintenance</span> for security updates, performance improvements, and new features.</p>
                  <p className="cta">📌 <strong>Learn about our maintenance plans.</strong> <button onClick={handleShow} className="btn btn-sm border-primary text-primary">Contact Us</button></p>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <h6>Didn’t find your Questions ? No worries Just <span onClick={handleShow} style={{ color: "#002BFF", cursor: "pointer" }}>connect with us</span> we will resolve your query </h6>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FaqSection;
